import { h, Component } from 'preact';
import style from './style';
import { Button } from '@cube/blocks';
import callWith from '@os/call-with';

export class CcpaButtons extends Component {

	buttonClicked = (link) => {
		if (link.external) {
			window.open(link.url, '_blank', 'noopener');
		}
		else {
			window.location.href = link.url;
		}
	}

	render({ links }, { }) {
		return (
			<div class={style.buttons}>
				{links && links.map((link) =>
					(
						<div class={style.buttonWrapper}>
							<Button
								class={style.button}
								type="primary"
								brand="primary"
								onClick={callWith(this.buttonClicked, link)}
							>
								{link.text}
							</Button>
						</div>
					)
				)}
			</div>);
	}
}
